import * as React from 'react';
import * as ReactDOM from 'react-dom';

const headRoot = document.head;

export const CanvasHead = (props: {children: React.ReactNode}) =>
  ReactDOM.createPortal(props.children, headRoot);
